const headerData = [{
		types: "selection",
		columnwidth: 50,
	},
	{
		prop: "InvClassName",
		label: "产品线",
		columnwidth: 120,
	},
	{
		prop: "LEVEL2",
		label: "LEVEL2",
		columnwidth: 120,
	},
	{
		prop: "LEVEL3",
		label: "LEVEL3",
		columnwidth: 150,
	},
	{
		prop: "StartDate",
		label: "启效日期",
		columnwidth: 130,
	},
	{
		prop: "EndDate",
		label: "有效期至",
		columnwidth: 130,
	},
	{
		prop: "UnitName",
		label: "主计量单位",
		columnwidth: 120,
	},
	{
		prop: "MinQuantity",
		label: "最小数量（含）",
		columnwidth: 150,
	},
	{
		prop: "MaxQuantity",
		label: "最大数量（不含）",
		columnwidth: 140,
	},
	{
		prop: "FUnitName",
		label: "辅计量单位",
		columnwidth: 120,
	},
	{
		prop: "FMinQuantity",
		label: "辅最小数量（含）",
		columnwidth: 160,
	},
	{
		prop: "FMaxQuantity",
		label: "辅最大数量（不含）",
		columnwidth: 150,
	},
	{
		prop: "Coefficient",
		label: "系数",
		columnwidth: 100,
	},
	{
		prop: "CreatorName",
		label: "创建人",
		columnwidth: 120,
	},
	{
		prop: "CreateTime",
		label: "创建日期",
		columnwidth: 180,
	}
];
export default headerData;